import { memo, useState } from 'react';

import { ReactINTLProvider } from '@picsart/shared-services/services/localization';
import { getContext } from '@picsart/miniapps-sdk';

import type { IProvider } from 'providers/types';
import useMount from 'hooks/useMount';

function INTLProvider({ children }: IProvider) {
  const [language, setLanguage] = useState(getContext().general.language.getState);

  useMount(() => {
    getContext().general.language.subscribe(nextLanguage => setLanguage(nextLanguage));
  });

  return (
    <ReactINTLProvider projectName="cloud_storage,pa_miniapps" language={language}>
      {children}
    </ReactINTLProvider>
  );
}

export default memo(INTLProvider);
